import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_LISTING_GET_DAILY_PAST_SEVEN_DAYS_LEADS } from 'api/actionTypes';

export default async function getDailyPastSevenDaysLeads(
  { state, apiClient },
  { listingId, reload = false },
) {
  typeCheck('listingId::PositiveNumber', listingId);
  const statePath = ['listings', 'dailyPastSevenDaysLeads', listingId];

  if (state.exists(statePath) && !reload) {
    return state.get(statePath);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_LISTING_GET_DAILY_PAST_SEVEN_DAYS_LEADS,
    state: state,
    queryId: `${listingId}`,
    payload: {
      listingId,
    },
    onSuccess(leads) {
      state.set(statePath, leads);
    },
  });
}
